class EventEmitter {
  events;

  constructor() {
    this.events = Object.create(null);
  }

  addListener(type, listener, prepend = false) {
    if (this.events[type]) {
      if (prepend) {
        this.events[type].unshift(listener);
      } else {
        this.events[type].push(listener);
      }
    } else {
      this.events[type] = [listener];
    }
  }

  removeListener(type, listener) {
    if (Array.isArray(this.events[type])) {
      if (!listener) {
        delete this.events[type];
      } else {
        this.events[type] = this.events[type].filter((e) => e !== listener);
      }
    }
  }

  once(type, listener) {
    const only = (...args) => {
      listener.apply(this, args);
      this.removeListener(type, listener);
    };
    only.origin = listener;
    this.addListener(type, only);
  }

  has(type) {
    return Array.isArray(this.events[type]);
  }

  emit(type, ...args) {
    if (this.has(type)) {
      this.events[type].forEach((fn) => {
        fn.apply(this, args);
      });
    }
  }
}

export default new EventEmitter();
